import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// רשימת הנתיבים שבהם הבוט של index.html יוסתר (התחברות, הרשמה, תשלום)
const HIDDEN_ROUTES = [
  '/login',
  '/register',
  '/signup',
  '/payment',
  '/checkout',
  '/auth'
];

const DraggableBot = () => {
  const location = useLocation();

  useEffect(() => {
    // איתור אלמנט הבוט והחלון מתוך index.html
    const chatToggle = document.querySelector('.chat-toggle');
    const chatBox = document.getElementById('chatBox');
    const chatLabel = document.getElementById('chatLabel');

    if (!chatToggle) return;

    // בדיקה האם הנתיב הנוכחי נמצא ברשימת הדפים להסתרה
    const currentPath = (location?.pathname || window.location.pathname).toLowerCase();
    const shouldHide = HIDDEN_ROUTES.some((route) => currentPath.startsWith(route));

    if (shouldHide) {
      chatToggle.style.display = 'none';
      if (chatBox) chatBox.style.display = 'none';
      if (chatLabel) chatLabel.style.display = 'none';
    } else {
      chatToggle.style.display = 'block';
    }
  }, [location]);

  // הקומפוננטה אינה מייצרת שום HTML או חלון נוסף
  return null;
};

export default DraggableBot;
